import React from 'react';
import PropTypes from 'prop-types';

const MobileMenu = ({ closeMenu, isMenuOpened, openMenu, pathname }) => {
  const onMenuClick = (event) => {
    event.preventDefault();
    if (isMenuOpened) {
      closeMenu();
    } else {
      openMenu(pathname);
    }
  };

  return (
    <div className="mainMenu hide-for-xlarge hd-header__mainMenu--prominent">
      <button
        onClick={onMenuClick}
        aria-label="Menu"
        aria-owns="navigation-menu"
        aria-haspopup={isMenuOpened}
        className="hd-header__mainMenuBtn--prominent"
      />
    </div>
  );
};

MobileMenu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  isMenuOpened: PropTypes.bool,
  openMenu: PropTypes.func.isRequired,
  pathname: PropTypes.string,
};

export default MobileMenu;
